import * as Sentry from '@sentry/react';

/**
 * Creates and installs the ApiProvider
 */
export default {
  id: 'molten.SentryInit',
  sort: -400,
  /**
   * Kick off the check to see if the user's credentials are still valid
   */
  init: async molten => {
    const sentryOpts = molten.getConfig('sentry');
    molten.set('sentry', Sentry);
    if (!sentryOpts) {
      return;
    }
    Sentry.onLoad(() => {
      Sentry.init({
        enabled: sentryOpts.enabled != null ? sentryOpts.enabled : !!sentryOpts.dsn,
        dsn: sentryOpts.dsn,
        environment: sentryOpts.environment,
        integrations: [new Sentry.BrowserTracing({
          // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
          tracePropagationTargets: ['localhost', ...(sentryOpts.tracePropagationTargets || [])]
        }), new Sentry.Replay({
          maskAllText: false,
          maskAllInputs: false
        }), ...(sentryOpts.integrations || [])],
        // Performance Monitoring
        tracesSampleRate: sentryOpts.tracesSampleRate || 0.1,
        // Session Replay
        replaysSessionSampleRate: sentryOpts.replaysSessionSampleRate || 0,
        replaysOnErrorSampleRate: sentryOpts.replaysOnErrorSampleRate || 0.1
      });
    });
  },
  onLoggedIn: (molten, action) => {
    const sentryOpts = molten.getConfig('sentry');
    if (!sentryOpts) {
      return;
    }
    Sentry.setUser({
      username: action.profile.username
    });
  },
  onLoggedOut: molten => {
    const sentryOpts = molten.getConfig('sentry');
    if (!sentryOpts) {
      return;
    }
    Sentry.setUser(null);
  }
};